import React from 'react';
import './Partsneedinject.css';
import partbulb from '../../../imgs/partbulbs.webp';


const Partsneedinject = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">Which Parts Need Injection Molding Machines for Production?</h2>

                <div className="Ordinary-content">
                    <p className="Ordinary-text">Checking the most popular type of LED bulbs,
                        A-type, G-type, and T-type are suitable for production with an injection molding machine.
                        Their main structures which could lower costs in long-term business with
                        injection molding machines are the lamp covers and plastic housing.</p>
                    <p className="Ordinary-text">Then we need to know the dimension of the bulb,
                        the most common ones are produced in 60mm and 65mm diameter,
                        which mean A60 and A65 Led Bulb. The weight is important as well.
                        For example, the A60 covers a weight of around 6.5g.
                        The lighter the weight of the same type of light bulb,
                        the more difficult it is to make the molds.</p>
                </div>
                <div className="Ordinary">
                    <img src={partbulb} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Ordinary-text">Last but not least, how many LED bulbs do we want to produce per hour?
                    Then the injection molding machine manufacturer – Powerjet Plastic Machinery can choose
                    the right tonnage of
                    the machine and make sure the mould can meet the requirement</p>
                <p className="Ordinary-text">Aim for best selling for the LED lighting product,
                    quality and cost control of each part is important to manufacturers.
                    Color shade steady, evenly, smooth, and high transmittance for PC LED light bulb cover;
                    the housing part should be high heat conductive and heat-resistant PBT material.
                    While some manufacturers may need to use modified plastic kind,
                    your golden samples of each part need to send to us for reference.</p>
            </div>
        </div>
    );
};

export default Partsneedinject;
